export enum ChatActionType {
  SET_USERS_LIST = "SET_USERS_LIST",
  SET_SHOWEMOJI = "SET_SHOWEMOJI",
  SET_ACTIVE_MESSENGER = "SET_ACTIVE_MESSENGER",
  HANLDE_REACTION = "HANLDE_REACTION",
  SET_EDIT = "SET_EDIT",
  SET_CHAT_SCREEN = "SET_CHAT_SCREEN",
  SET_EMOJI_BOX = "SET_EMOJI_BOX",
  SET_DELETE_MODAL = "SET_DELETE_MODAL",
  SET_CHAT_INSTANCE = "SET_CHAT_INSTANCE",
  SET_ACTIVE_CHAT = "SET_ACTIVE_CHAT",
  SET_SEARCH_RESULT_CHAT = "SET_SEARCH_RESULT_CHAT",
  UNSET_SEARCH_RESULT_CHAT = "UNSET_SEARCH_RESULT_CHAT",
  HANDLE_CHAT_MESSAGE = "HANDLE_CHAT_MESSAGE",
  SET_PERSONAL_INFO = "SET_PERSONAL_INFO",
  SET_CHAT_CALL_MIC = "SET_CHAT_CALL_MIC",
  SET_CHAT_CALL_CAMERA = "SET_CHAT_CALL_CAMERA",
  SET_CHAT_CALL_SCREENSHARE = "SET_CHAT_CALL_SCREENSHARE",
  SET_CHAT_CALL_INFO = "SET_CHAT_CALL_INFO",
  SET_OPTION_BOX = "SET_OPTION_BOX",
  SET_REPLY_MSG = "SET_REPLY_MSG",
  SET_REPLY_FLAG = "SET_REPLY_FLAG",
  SET_PAST_MESSAGES = "SET_PAST_MESSAGES",
  SET_CREATE_GRP_OPTION = "CREATE_GRP_OPTION",
  SET_NEW_CHAT_OPTION = "SET_NEW_CHAT_OPTION",
  SET_CREATE_GRP_MODAL = "SET_CREATE_GRP_MODAL",
  SET_MEMBER_BUBBLE_DELETE = "SET_MEMBER_BUBBLE_DELETE",
  HANDLE_SEEN = "HANDLE_SEEN",
  HANDLE_ONLINE_STATUS = "HANDLE_ONLINE_STATUS",
  SET_GROUPS_LIST = "SET_GROUPS_LIST",
  HANDLE_DELETE = "HANDLE_DELETE",
  SET_CALL = "SET_CALL",
  FLAG_SET_CALL = "FLAG_SET_CALL",
  HANDLE_EDIT = "HANDLE_EDIT",
  SET_SHARE_MSG_MODAL = "SET_SHARE_MSG_MODAL",
  SET_ADD_ADMIN_MODAL = "SET_ADD_ADMIN_MODAL",
  SET_TWO_OPTION_MODAL = "SET_TWO_OPTION_MODAL",
  UNSET_UNREAD = "UNSET_UNREAD",
  UPDATE_GROUP_DATA = "UPDATE_GROUP_DATA",
  IS_SCROLLED = "IS_SCROLLED",
  SET_CHAT_BY_UUID = "SET_CHAT_BY_UUID",
  SET_DRAFT_MESSAGE = "SET_DRAFT_MESSAGE",
  REMOVE_GROUP_MEMBER = "REMOVE_GROUP_MEMBER",
  ALIGN_ONE_SIDE = "ALIGN_ONE_SIDE",
  ADD_NEW_CHAT = "ADD_NEW_CHAT",
  ADD_GROUP_MEMBER = "ADD_GROUP_MEMBER",
  SET_ATTACHMENT = "SET_ATTACHMENT",
  SET_ATTACHMENT_URL = "SET_ATTACHMENT_URL",
  SET_UPLOADING_STATUS = "SET_UPLOADING_STATUS",
  SET_INCOMING_CALL = "SET_INCOMING_CALL",
  UNSET_INCOMING_CALL = "UNSET_INCOMING_CALL",
  INCOMING_CALL_MODAL = "INCOMING_CALL_MODAL",
  SET_CHAT_DATA_UPDATE = "SET_CHAT_DATA_UPDATE",
  SET_UPLOADING_FAILED = "SET_UPLOADING_FAILED",
  UNSET_ACTIVE_CHAT = "UNSET_ACTIVE_CHAT",
  SET_ARROWUP_EDIT = "SET_ARROWUP_EDIT",
  SET_TYPING_INDICATOR = "SET_TYPING_INDICATOR",
  UNSET_TYPING_INDICATOR = "UNSET_TYPING_INDICATOR",
  HANDLE_MESSAGES_IN_LIMBO = "HANDLE_MESSAGES_IN_LIMBO",
  ARCHIVE_GROUP = "ARCHIVE_GROUP",
  HANDLE_PIN_MESSAGE = "HANDLE_PIN_MESSAGE",
  KICK_OUT = "KICK_OUT",
  MESSAGE_DELIVERED = "MESSAGE_DELIVERED",
  CALL_DATA = "CALL_DATA",
  UPDATE_CACHED_MESSAGES = "UPDATE_CACHED_MESSAGES",
  SEARCH_FLAG = "SEARCH_FLAG",
  HOVERED_MESSAGE = "HOVERED_MESSAGE",
  UPDATE_OPTIONS = "UPDATE_OPTIONS",
  SEARCH_ACTIVE_CHAT = "SEARCH_ACTIVE_CHAT",
  CALL_TOGGLE = "CALL_TOGGLE",
  CALL_MEETING_DATA = "CALL_MEETING_DATA",
  REJECT_REASON_MODAL = "REJECT_REASON_MODAL",
  PINNED_CHAT = "PINNED_CHAT",
  SELF_DATA = "SELF_DATA",
  SET_MINI_PROFILE = "SET_MINI_PROFILE",
  SET_PERSONAL_STATUS = "SET_PERSONAL_STATUS",
  CALL_CONNECTED = "CALL_CONNECTED",
  SET_MEETING_MODAL = "SET_MEETING_MODAL",
  SETACTIVEPLAYING = "SETACTIVEPLAYING",
  CALL_TOGGLE_FLAG = "CALL_TOGGLE_FLAG",
  SET_CHAT_MESSAGE = "SET_CHAT_MESSAGE",
  SET_MINI_UUID = "SET_MINI_UUID",
  SET_MQTT_STATUS = "SET_MQTT_STATUS",
  SET_NOTIFICATION = "SET_NOTIFICATION",
  SET_INVITE_STATE = "SET_INVITE_STATE",
  GOTOFILE = "GOTOFILE",
  SET_MENTION_UUID = "SET_MENTION_UUID",
  CLEAR_CHAT_DATA = "CLEAR_CHAT_DATA",
  CALL_RECONNECTION = "CALL_RECONNECTION",
  UPDATE_USER_EVENT = "UPDATE_USER_EVENT",
  ENABLE_DISABLE_EVENT = "ENABLE_DISABLE_EVENT",
  MEET_CREDENTIALS = "MEET_CREDENTIALS",
  END_CALL = "END_CALL",
  SET_MULTIPLE_MSG_SELECT = "SET_MULTIPLE_MSG_SELECT",
  SET_MULTIPLE_MSG_LIST = "SET_MULTIPLE_MSG_LIST",
  SET_SELF_CHAT = "SET_SELF_CHAT",
  HANDLE_SELF_CHAT = "HANDLE_SELF_CHAT",
  SET_FORWARD_MODAL = "SET_FORWARD_MODAL",
  FORWARD_MSG = "FORWARD_MSG",
  HANDLE_FORWARD = "HANDLE_FORWARD",
  CALL_HANDLING_MODAL = "CALL_HANDLING_MODAL",
  SET_CALL_HANDLING_DATA = "SET_CALL_HANDLING_DATA",
  GROUP_CALL_HANDLING_MODAL = "GROUP_CALL_HANDLING_MODAL",
  KICK_OUT_STATE = "KICK_OUT_STATE",
  SET_GROUP_CALL_TYPE = "SET_GROUP_CALL_TYPE",
  SET_AI_MODAL = "SET_AI_MODAL",
}
